export class RegisterUserRequest {
    public name: string = "";
    public email: string = "";
    public password: string = "";
    public product: string = "";
    public companyName: string = "";
    public phoneNumber: string = "";
}